var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-login"},[_c('div',{staticClass:"main-login__bg",style:({
			backgroundImage:
				'url(' + require('@/assets/images/background.jpg') + ')',
		})},[_c('img',{staticClass:"main-login__bg-logo",attrs:{"src":require('@/assets/images/logo-confipetrol.png'),"alt":""}})]),_c('div',{staticClass:"main-login__form"},[_c('reset-password')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }